export const schema = {
    id: 'i18n',
    name: get => `${get('lang')} 译文`,
    fieldUncheckable: true,
    pickFields: ['translation'],
};
